import $ from 'jquery'

const dfp = {};

dfp.push = (format, conditions) => {

    if (conditions === "" || conditions === undefined) {
        window.googletag.cmd.push(function () {
            window.googletag.display(format);
        })
    } else {
        if (eval(window.innerWidth + conditions)) {
            window.googletag.cmd.push(function () {
                window.googletag.display(format);
            })
        }
    }
};

dfp.domInjection = (dfpUrl) => {

    if (dfpUrl) {
        let script = document.createElement('script');
        let node = document.getElementsByTagName('body')[0];

        script.type = 'text/javascript';
        script.async = true;
        script.defer = false;
        script.src = dfpUrl;
        node.appendChild(script);
    }
};


dfp.initializedfp = () => {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    let section = $('meta[content][name="sectionTarget"]').attr('content');
    let type = $('meta[content][name="type"]').attr('content');
    let articleId = $('meta[content][name="articleId"]').attr('content');

    googletag.cmd.push(function() {
        googletag.pubads().addEventListener("slotRenderEnded", function handler(event) {
            const slot = event.slot;
            if (event.isEmpty) {
                let slotElement = slot.getSlotElementId();
                googletag.destroySlots([slot]);
                console.log(slotElement);
                $( '#' + slotElement ).remove();
            }
        });
    });

    if (window.innerWidth > 650) {
        window.googletag.cmd.push(function () {
            if (type === 'home') {
                window.googletag.defineSlot('/60012700/billboard1', [970, 120], 'Billboard').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard1', [970, 90], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [970, 90], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [970, 90], 'Leaderboard_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard4', [970, 90], 'Leaderboard_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [970, 90], 'Leaderboard_5').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/skyright', [160, 600], 'Sky_R').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/skyleft', [160, 600], 'Sky_L').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());
            } else if (type === 'thematic') {
                window.googletag.defineSlot('/60012700/leaderboard1', [970, 90], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [970, 90], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [970, 90], 'Leaderboard_3').addService(window.googletag.pubads());


                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [970, 90], 'Leaderboard_5').addService(window.googletag.pubads());
            } else if (type === 'article') {
                window.googletag.defineSlot('/60012700/leaderboard1', [970, 90], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [970, 90], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [970, 90], 'Leaderboard_3').addService(window.googletag.pubads());


                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [970, 90], 'Leaderboard_5').addService(window.googletag.pubads());
            } else {
                window.googletag.defineSlot('/60012700/billboard1', [970, 120], 'Billboard').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard1', [970, 90], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [970, 90], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [970, 90], 'Leaderboard_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard4', [970, 90], 'Leaderboard_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [970, 90], 'Leaderboard_5').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/skyright', [160, 600], 'Sky_R').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/skyleft', [160, 600], 'Sky_L').addService(window.googletag.pubads());
            }

            window.googletag.pubads().enableSingleRequest();
            window.googletag.pubads().setTargeting('Section', [section]);
            window.googletag.pubads().setTargeting('ArticleId', [articleId]);
            window.googletag.pubads().setTargeting('Type', [type]);

            window.googletag.enableServices();
        });
    } else {
        window.googletag.cmd.push(function () {
            if (type === 'home') {
                window.googletag.defineSlot('/60012700/billboard1', [[300, 50], [320,100]], 'Billboard').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard1', [[300, 50], [320,100]], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [[300, 50], [320,100]], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [[300, 50], [320,100]], 'Leaderboard_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard4', [[300, 50], [320,100]], 'Leaderboard_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [[300, 50], [320,100]], 'Leaderboard_5').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/skyright', [160, 600], 'Sky_R').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/skyleft', [160, 600], 'Sky_L').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());

            } else if (type === 'thematic') {
                window.googletag.defineSlot('/60012700/leaderboard1', [[300, 50], [320,100]], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [[300, 50], [320,100]], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [[300, 50], [320,100]], 'Leaderboard_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [[300, 50], [320,100]], 'Leaderboard_5').addService(window.googletag.pubads());
            } else if (type === 'article') {
                window.googletag.defineSlot('/60012700/leaderboard1', [[300, 50], [320,100]], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [[300, 50], [320,100]], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [[300, 50], [320,100]], 'Leaderboard_3').addService(window.googletag.pubads());

                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_Mobile_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_Mobile_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_Mobile_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_Mobile_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [[300, 50], [320,100]], 'Leaderboard_5').addService(window.googletag.pubads());
            } else {
               /* window.googletag.defineSlot('/60012700/mediummobile1', [300, 250], 'Medium_Mobile_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/mediummobile2', [300, 250], 'Medium_Mobile_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/mediummobile3', [300, 250], 'Medium_Mobile_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/mediummobile4', [300, 250], 'Medium_Mobile_4').addService(window.googletag.pubads());*/
                window.googletag.defineSlot('/60012700/medium1', [300, 250], 'Medium_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium2', [300, 250], 'Medium_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium3', [300, 250], 'Medium_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/medium4', [300, 250], 'Medium_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard1', [[300, 50], [320,100]], 'Leaderboard_1').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard2', [[300, 50], [320,100]], 'Leaderboard_2').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard3', [[300, 50], [320,100]], 'Leaderboard_3').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard4', [[300, 50], [320,100]], 'Leaderboard_4').addService(window.googletag.pubads());
                window.googletag.defineSlot('/60012700/leaderboard5', [[300, 50], [320,100]], 'Leaderboard_5').addService(window.googletag.pubads());
            }

            window.googletag.pubads().enableSingleRequest();
            window.googletag.pubads().collapseEmptyDivs();
            window.googletag.pubads().setTargeting('section', [section]);
            window.googletag.pubads().setTargeting('ArticleId', [articleId]);
            window.googletag.pubads().setTargeting('Type', [type]);
            window.googletag.enableServices();

        });
    }

};

export default dfp;